/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_RegisteringInputs */

const en_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registering…`)
};

const es_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrando…`)
};

const de_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird angemeldet…`)
};

const zh_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在报名…`)
};

const ar_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ التسجيل…`)
};

const fr_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription…`)
};

const vi_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đăng ký…`)
};

const sw_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inasajili…`)
};

const th_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังลงทะเบียน…`)
};

const bs_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registracija…`)
};

const ja_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録中…`)
};

const ko_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록 중…`)
};

const pt_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrevendo…`)
};

const it_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione…`)
};

const sv_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmäler…`)
};

const nl_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inschrijven…`)
};

const da_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilmelder…`)
};

const nb_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melder på…`)
};

const fi_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoittaudutaan…`)
};

const pl_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestracja…`)
};

const ru_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрируем…`)
};

const tr_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydediliyor…`)
};

const hi_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकरण हो रहा है…`)
};

const id_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendaftar…`)
};

const ms_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendaftar…`)
};

const cs_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrujeme…`)
};

const el_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εγγραφή…`)
};

const he_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נרשמים…`)
};

const af_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registreer tans…`)
};

const hu_events_registering = /** @type {(inputs: Events_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regisztrálás…`)
};

/**
* | output |
* | --- |
* | "Registering…" |
*
* @param {Events_RegisteringInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_registering = /** @type {((inputs?: Events_RegisteringInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_RegisteringInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_registering(inputs)
	if (locale === "de") return de_events_registering(inputs)
	if (locale === "zh") return zh_events_registering(inputs)
	if (locale === "ar") return ar_events_registering(inputs)
	if (locale === "fr") return fr_events_registering(inputs)
	if (locale === "vi") return vi_events_registering(inputs)
	if (locale === "sw") return sw_events_registering(inputs)
	if (locale === "th") return th_events_registering(inputs)
	if (locale === "bs") return bs_events_registering(inputs)
	if (locale === "ja") return ja_events_registering(inputs)
	if (locale === "ko") return ko_events_registering(inputs)
	if (locale === "pt") return pt_events_registering(inputs)
	if (locale === "it") return it_events_registering(inputs)
	if (locale === "sv") return sv_events_registering(inputs)
	if (locale === "nl") return nl_events_registering(inputs)
	if (locale === "da") return da_events_registering(inputs)
	if (locale === "nb") return nb_events_registering(inputs)
	if (locale === "fi") return fi_events_registering(inputs)
	if (locale === "pl") return pl_events_registering(inputs)
	if (locale === "ru") return ru_events_registering(inputs)
	if (locale === "tr") return tr_events_registering(inputs)
	if (locale === "hi") return hi_events_registering(inputs)
	if (locale === "id") return id_events_registering(inputs)
	if (locale === "ms") return ms_events_registering(inputs)
	if (locale === "cs") return cs_events_registering(inputs)
	if (locale === "el") return el_events_registering(inputs)
	if (locale === "he") return he_events_registering(inputs)
	if (locale === "af") return af_events_registering(inputs)
	if (locale === "hu") return hu_events_registering(inputs)
	return en_events_registering(inputs)
});